<style>
</style>
<template>
<div>
  <v-list-item dense>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click.native.stop="removeItem(value)" v-on="on">
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Odstranit položku') }}</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-content dense>
      <v-list-item-title>{{ value.itemName }}</v-list-item-title>
      <!-- <v-icon>close</v-icon> -->
      <v-list-item-subtitle dense>
        <v-row dense>
          <v-col class="text-left">
            <v-tooltip bottom v-if="value.canChangeVolume">
              <span>{{ $t('Snížit množství') }}</span>
              <template v-slot:activator="{ on }">
                <v-btn icon @click.native.stop="decrementItem(value)" v-on="on">
                  <v-icon dark>mdi-minus-circle-outline</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <span>{{ value.volume }} {{ 'ks' }}</span>
            <v-tooltip bottom v-if="value.canChangeVolume">
              <span>{{ $t('Zvýšit množství') }}</span>
              <template v-slot:activator="{ on }">
                <v-btn icon @click.native.stop="incrementItem(value)" v-on="on">
                  <v-icon dark>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col class="text-right">
            <span :class="{ 'font-weight-bold': true, 'green--text': value.useCredit != true, 'red--text': value.useCredit != false }">{{ value.useCredit ? value.creditPrice : value.price | currency }}</span>
          </v-col>
        </v-row>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-divider></v-divider>
</div>
</template>
<script>
import BasketMixin from '../mixins/basket-mixin.js'
export default {
  mixins: [BasketMixin],
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
